module.exports = __webpack_public_path__ + "img/12.234c6232.jpg";